"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _ol = require("ol");

var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON"));

var _Vector = _interopRequireDefault(require("ol/layer/Vector"));

var _Vector2 = _interopRequireDefault(require("ol/source/Vector"));

var _Style = _interopRequireDefault(require("ol/style/Style"));

var _Icon = _interopRequireDefault(require("ol/style/Icon"));

var _useNominatimGeocoder3 = _interopRequireDefault(require("../../../../hooks/geocoder/useNominatimGeocoder"));

var _usePrevious = _interopRequireDefault(require("../../../../hooks/common/usePrevious"));

var _map = require("../../../../util/map");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["map", "placeholder", "value", "fetchOpts", "delay", "allowClear", "onSelect", "onSearch", "onChange", "onSelectFeature", "showOnMap", "defaultIcon"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Component to allow a selection of a place through a 
 * list of places retrieved dynamically through the 
 * <a href="https://nominatim.org/release-docs/latest/api/Search/">
 *  Nominatim Geocoder
 * </a>.
 * 
 * Check <a href="https://ant.design/components/auto-complete/">
 * Antd AutoComplete</a> component for additional properties.
 * 
 * @visibleName Nominatim Geocoder AutoComplete 
 */
var NominatimGeocoderAutoComplete = function NominatimGeocoderAutoComplete(_ref) {
  var map = _ref.map,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Select a place" : _ref$placeholder,
      value = _ref.value,
      fetchOpts = _ref.fetchOpts,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 1000 : _ref$delay,
      _ref$allowClear = _ref.allowClear,
      allowClear = _ref$allowClear === void 0 ? true : _ref$allowClear,
      onSelect = _ref.onSelect,
      onSearch = _ref.onSearch,
      onChange = _ref.onChange,
      onSelectFeature = _ref.onSelectFeature,
      _ref$showOnMap = _ref.showOnMap,
      showOnMap = _ref$showOnMap === void 0 ? true : _ref$showOnMap,
      _ref$defaultIcon = _ref.defaultIcon,
      defaultIcon = _ref$defaultIcon === void 0 ? "https://www.google.com/mapfiles/marker.png" : _ref$defaultIcon,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      setCurrentPlace = _useState4[1];

  var _useNominatimGeocoder = (0, _useNominatimGeocoder3.default)(),
      _useNominatimGeocoder2 = _slicedToArray(_useNominatimGeocoder, 4),
      sendRequest = _useNominatimGeocoder2[0],
      places = _useNominatimGeocoder2[2],
      timeoutId = _useNominatimGeocoder2[3];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      internalVectorLayer = _useState6[0],
      setInternalVectorLayer = _useState6[1];

  var previousValue = (0, _usePrevious.default)(value);

  if (value !== previousValue && value !== currentValue) {
    setCurrentValue(value);
  }

  var onInternalSelect = (0, _react.useCallback)(function (value, option) {
    //setCurrentValue(value);
    setCurrentPlace(option);
    setCurrentValue(value); //parse feature

    var geoJsonParser = new _GeoJSON.default();
    var feature = geoJsonParser.readFeature(option.feature, {
      dataProjection: 'EPSG:4326',
      featureProjection: map.getView().getProjection()
    }); //draw feature on the map

    if (map && showOnMap) {
      if (internalVectorLayer) {
        internalVectorLayer.getSource().clear();
        internalVectorLayer.getSource().addFeature(feature);
        (0, _map.ZoomToFeatures)(map, [feature]);
      }
    }

    onSelect && onSelect(value, option); //call event handler

    onSelectFeature && onSelectFeature(value, feature, option.feature);
  }, [onSelect, showOnMap, map, onSelectFeature, internalVectorLayer]);
  var onInternalSearch = (0, _react.useCallback)(function (value) {
    if (value && value.length > 2) {
      clearTimeout(timeoutId);
      sendRequest(value, delay, fetchOpts);
    }

    onSearch && onSearch(value);
  }, [onSearch, sendRequest, timeoutId, delay, fetchOpts]);
  var onInternalChange = (0, _react.useCallback)(function (value) {
    setCurrentValue(value);

    if (!value) {
      //clear feature on the map
      if (internalVectorLayer) {
        internalVectorLayer.getSource().clear();
      }
    }

    onChange && onChange(value);
  }, [onChange, internalVectorLayer]);
  (0, _react.useEffect)(function () {
    var newVectorLayer = null;

    if (map && showOnMap && !internalVectorLayer) {
      newVectorLayer = new _Vector.default({
        name: 'Nominatim Geocoding',
        source: new _Vector2.default(),
        style: new _Style.default({
          image: new _Icon.default({
            anchor: [0.5, 1],
            src: defaultIcon
          })
        })
      });
      setInternalVectorLayer(newVectorLayer);
      map.addLayer(newVectorLayer);
    }

    return function () {
      internalVectorLayer && map.removeLayer(internalVectorLayer);
    };
  }, [map, showOnMap, internalVectorLayer, defaultIcon]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.AutoComplete, _objectSpread({
    value: currentValue,
    options: places,
    allowClear: allowClear,
    onSelect: onInternalSelect,
    onChange: onInternalChange,
    onSearch: onInternalSearch,
    placeholder: placeholder
  }, otherProps));
};

NominatimGeocoderAutoComplete.propTypes = {
  /**
   * The OpenLayers ol/Map where the place will be rendered.
   */
  map: _propTypes.default.instanceOf(_ol.Map),

  /**
   * The placeholder for the autocomplet component.
   */
  placeholder: _propTypes.default.string,

  /**
   * Show the clear button to clear the input.
   * If the place is shown in the map, it will
   * be removed after the user clears the input.
   */
  allowClear: _propTypes.default.bool,

  /**
   * Called when a option is selected. param is option's value and option instance
   * @ignore
   */
  onSelect: _propTypes.default.func,

  /**
   * Called when a option is selected. param is projection option's value, 
   * the openlayers ol/Feature representing 
   * the place and the <i>javascript object</i> place retrieved from 
   * the geocoder.
   */
  onSelectFeature: _propTypes.default.func,

  /**
   * Called when select an option or input value change, 
   * or value of input is changed. The param is the input value.
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * Called when searching items
   * @ignore
   */
  onSearch: _propTypes.default.func,

  /**
   * Selected place
   * @ignore
   */
  value: _propTypes.default.string,

  /**
   * If true, the place will be shown
   * in the map.
   */
  showOnMap: _propTypes.default.bool,

  /**
   * The icon to be shown in the map representing
   * the selected place.
   */
  defaultIcon: _propTypes.default.string,

  /**
   * time delay (in milliseconds) to send the autocomplete request,
   * to avoid that a request will be sent everytime
   * the user type a letter.
   */
  delay: _propTypes.default.number,

  /**
   * Additional options to be used for the 
   * <a href="https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch">fetch API</a>.
   */
  fetchOpts: _propTypes.default.object
};
var _default = NominatimGeocoderAutoComplete;
exports.default = _default;